import { convertDateTime } from '../helper-functions/convertdatetime';
import moment from 'moment';

export class DateTimeConverterValueConverter {

  toView(value: moment.MomentInput) {
    return convertDateTime(value);
  }

  fromView(value: unknown) {
    return value;
  }
}
